import { useParamsSearch } from '@anytag/shared-hooks';
import { AutoManagedCampaignsSearchSchemaType } from '../schemaTypes';

export const useAutoManagedCampaignsFilter = () => useParamsSearch<AutoManagedCampaignsSearchSchemaType>();
